import { render } from "./CompleteAccount.vue?vue&type=template&id=778106e4&ts=true"
import script from "./CompleteAccount.vue?vue&type=script&lang=ts"
export * from "./CompleteAccount.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__